export interface Notification {
  id: string
  title: string
  description: string
  date: string
  status: 'Read' | 'Unread'
}

export const mockNotifications: Notification[] = [
  { id: '1', title: 'New lead assigned', description: 'TechStart Inc. has been assigned to your queue.', date: '2026-05-28 09:15', status: 'Unread' },
  { id: '2', title: 'Deal approved', description: 'Global Retail deal #D-2847 approved by manager.', date: '2026-05-28 08:30', status: 'Unread' },
  { id: '3', title: 'System maintenance', description: 'Scheduled maintenance on June 2, 2026 02:00 UTC.', date: '2026-05-27 16:00', status: 'Read' },
  { id: '4', title: 'Password policy update', description: 'New password requirements effective next week.', date: '2026-05-27 10:00', status: 'Read' },
  { id: '5', title: 'Ticket escalated', description: 'TKT-1040 escalated to billing team.', date: '2026-05-26 14:22', status: 'Unread' },
  { id: '6', title: 'New user registered', description: 'Emily Taylor joined as Agent.', date: '2026-05-26 09:00', status: 'Read' },
]
